<template>
  <div id="informacion-obligacion">
    <v-dialog v-model="dialog" :max-width="700" :style="{ zIndex: 200 }">
      <v-card>
        <v-toolbar dark color="info" dense flat>
          <v-toolbar-title class="white--text">
            Informacion de pagos
            <v-progress-linear
              :active="loading"
              :indeterminate="loading"
              absolute
              bottom
              color="gold"
            />
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-data-table
            :headers="headers"
            :items="pagos"
            disable-sort
          >
            <template v-slot:[`item.fechaPago`]="{ item }">
              {{ formatDate(item) }}
            </template>
            <template v-slot:[`item.numeroRecibo`]="{ item }">
              {{ generarNumero(item) }}
            </template>
            <template v-slot:[`item.monto`]="{ item }">
              {{ montoMoneda(item) }}
            </template>
            <template v-slot:[`item.pdf`]="{ item }">
              <div v-if="obligacion.pagos_id">
                <v-icon small class="mr-2" @click.stop="mostrarPdfPago(item)">
                  mdi-file-pdf-box
                </v-icon>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import GeneradorPdfRecibojs from '../mixins/generadorPdfRecibo'
  import dayjs from 'dayjs'

  export default {
    name: 'InformacionObligacion',
    mixins: [GeneradorPdfRecibojs],
    props: {
      obligacion: {
        type: Object,
        required: false,
        default: null,
      },
      toggle: {
        type: Boolean,
        required: true,
        default: true,
      },
    },
    data () {
      return {
        headers: [
          { text: 'Fecha', align: 'start', sortable: true, value: 'fechaPago' },
          { text: 'Pago numero', sortable: true, value: 'numeroRecibo' },
          { text: 'Monto', sortable: true, value: 'monto' },
          { text: 'Ver', sortable: true, value: 'pdf' },
        ],
        dialog: false,
        loading: true,
        pagos: [],
      }
    },
    computed: {},
    watch: {
      toggle (val) {
        this.mostrarInfo()
      },
    },
    created () {
    },
    methods: {
      mostrarInfo () {
        this.loading = true
        this.dialog = true
        this.getPago()
      },

      mostrarPdfPago (item) {
        this.generarPdfPago(this.obligacion.pagos_id)
      },

      getPago: async function () {
        if (this.obligacion.pagos_id) {
          this.$store.dispatch('axiosMod/getData', { url: '/api/pagos/' + this.obligacion.pagos_id }).then(response => {
            this.pagos = []
            this.pagos.push(response)
            this.loading = false
          })
        } else {
          this.pagos = this.generarValorMonetario()
          this.loading = false
        }
      },

      generarValorMonetario: function () {
        return [{ fechaPago: 'Sin Fecha', numeroRecibo: 'Sin Recibo', monto: '$' + this.obligacion.valor_monetario }]
      },

      formatDate (item) {
        if (this.obligacion.pagos_id) {
          return dayjs(item.fecha).format('YYYY-MM-DD')
        } else {
          return item.fechaPago
        }
      },

      generarNumero (item) {
        if (this.obligacion.pagos_id) {
          return (('00000000' + item.id).slice(-8))
        } else {
          return ''
        }
      },

      montoMoneda (item) {
        if (this.obligacion.pagos_id) {
          return (item.moneda.simbolo + ' ' + item.monto)
        } else {
          return item.monto
        }
      },
    },
  }
</script>
